// See @store/AppPhaseStore.ts for the store loading order.
import { create } from 'zustand';
import { Visualization } from '../rendering/Visualizer';

type ViewerStore = {
    viewer: Visualization | null;
    ensureViewer: () => Visualization;
    refreshViewer: () => void;
    activeSensorPoints: number;
    setActiveSensorPoints: (count: number) => void;
};

const activeSensorPoints = 0;
const useViewerStore = create<ViewerStore>((set, get) => ({
    viewer: null,
    ensureViewer: () => {
        const existingViewer = get().viewer;
        if (existingViewer) return existingViewer;

        const nextViewer = new Visualization();
        set({ viewer: nextViewer });
        return nextViewer;
    },
    refreshViewer: () => {
        console.warn('REFRESHING VIEWER');

        const nextViewer = new Visualization();
        set({ viewer: nextViewer });
        nextViewer.initialize();
    },
    activeSensorPoints,
    setActiveSensorPoints: (count: number) => {
        set({ activeSensorPoints: count });
    },
}));

export default useViewerStore;

export function getViewer(): Visualization {
    return useViewerStore.getState().ensureViewer();
}
